import React from 'react';
import { Form, Button } from 'semantic-ui-react';

class PatientsDateFilter extends React.Component {
  /*state = {
    text: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  };*/
  constructor(props) {
    super(props);
    const { text = '', startDate, endDate } = props.initialFilter || {};
    this.state = {
      text,
      startDate: startDate || new Date().toISOString().split('T')[0],
      endDate: endDate || new Date().toISOString().split('T')[0]
    };
  }

  componentDidUpdate(prevProps) {
    const { initialFilter } = this.props

    if (prevProps.initialFilter !== initialFilter) {
      const { text = '', startDate, endDate } = initialFilter || {};
      this.setState({
        text,
        startDate: startDate || new Date().toISOString().split('T')[0],
        endDate: endDate || new Date().toISOString().split('T')[0]
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { text, startDate, endDate } = this.state;

    // Le envía los filtros al componente padre (PatientSection)
    this.props.onFilterSubmit({
      text,
      startDate,
      endDate
    });
  };

  render() {
    const { text, startDate, endDate } = this.state;

    return (
      <Form>
        <Form.Group widths="equal">
          <Form.Input
            label="Nombre / Identificación / Historia"
            placeholder="Buscar por nombre, identificación o historia"
            name="text"
            value={text}
            onChange={this.handleChange}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Input
            type="date"
            label="Fecha Inicio"
            name="startDate"
            value={startDate}
            onChange={this.handleChange}
          />
          <Form.Input
            type="date"
            label="Fecha Fin"
            name="endDate"
            value={endDate}
            onChange={this.handleChange}
          />
        </Form.Group>

        <Button primary onClick={this.handleSubmit}>
          Buscar
        </Button>
      </Form>
    );
  }
}

export default PatientsDateFilter;
